import {NodeChunk} from "../../chunks/types/NodeChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getNodeNameFromNodeChunk(
  nodeChunk: NodeChunk
): string | null {
  const {
    captures: {
      2: nameChunk
    }
  } = nodeChunk;
  return nameChunk && getNameFromIdentifierChunk(nameChunk);
}
